/* src/app/core/error-page/error-page.component.scss */
/*# sourceMappingURL=error-page.component.css.map */
